import { useRef, useEffect } from 'react';

import { Label } from '@hivebrite/design-system/Label';
import { usePrevious } from '@hivebrite/react-hooks';

import InputLocation from 'hb-react/shared/components/DesignSystem/Inputs/InputLocation';
import { type InputLocationRef } from 'hb-react/shared/components/DesignSystem/Inputs/InputLocation/types';
import { type Location } from 'hb-react/types';

interface LocationSearchProps {
  id: string;
  onChange: (value: Location) => void;
  value: Location;
}

const LocationSearch = ({ id, value, onChange }: LocationSearchProps) => {
  const componentRef = useRef<InputLocationRef>(null);

  const prevValue = usePrevious(value);

  useEffect(() => {
    const hasValue = (val?: Location) => val?.location;

    if (hasValue(prevValue) && !hasValue(value)) {
      componentRef.current?.resetLocationState();
    }
  }, [prevValue, value]);

  return (
    <>
      <Label id={id}>{s__('Mentoring|Location')}</Label>
      <InputLocation
        inputName="location"
        id={id}
        placeholder={__('Type and select a location')}
        // @ts-expect-error type Location mismatches
        defaultLocation={{ ...value, address: value?.location }}
        // @ts-expect-error type Location mismatches
        onSelectLocation={onChange}
        componentRef={componentRef}
      />
    </>
  );
};

export default LocationSearch;
